module.exports = __webpack_public_path__ + "static/media/ngo.7671f712.jpeg";